





















































import { clipboardText } from '@/app/core/utils'
import { Toast } from 'vant'
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { CommissionMixin } from '../commission.mixin'

@Component
export default class SpuComponent extends CommissionMixin {
  @Prop() item!: any
  @Prop() filterStatus!: any

  async copyButtonClick(text: string) {
    try {
      await clipboardText(text)
      Toast('复制成功')
    } catch (e) {
      Toast('复制失败')
    }
  }
}
